import { render, staticRenderFns } from "./UserTalking.vue?vue&type=template&id=416d95a6&scoped=true"
import script from "./UserTalking.vue?vue&type=script&lang=js"
export * from "./UserTalking.vue?vue&type=script&lang=js"
import style0 from "./UserTalking.vue?vue&type=style&index=0&id=416d95a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d95a6",
  null
  
)

export default component.exports